import type React from 'react';

import { Resources } from './components/Resources';
import { Social } from './components/Social';

export const ResourcesAndSocial: React.FC<EmptyProps> = () => {
	return (
		<section className="container pb-16 md:pb-32">
			<div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-18" data-qa="press-resources-social-grid">
				<Resources />
				<Social />
			</div>
		</section>
	);
};
